/**
 * AT Home Category Nav — premium rail + accordion + dots/arrows
 */
(function () {
  function closeAll(cards, except) {
    cards.forEach(function (card) {
      if (card === except) return;
      card.classList.remove("is-open");
      var btn = card.querySelector("[data-at-catnav-toggle]");
      if (btn) {
        btn.setAttribute("aria-expanded", "false");
        btn.setAttribute("aria-label", "Alt kategorileri aç");
      }
    });
  }

  function setOpen(card, open) {
    var btn = card.querySelector("[data-at-catnav-toggle]");
    if (open) {
      card.classList.add("is-open");
      if (btn) {
        btn.setAttribute("aria-expanded", "true");
        btn.setAttribute("aria-label", "Alt kategorileri kapat");
      }
    } else {
      card.classList.remove("is-open");
      if (btn) {
        btn.setAttribute("aria-expanded", "false");
        btn.setAttribute("aria-label", "Alt kategorileri aç");
      }
    }
  }

  function init(root) {
    var section = (root || document).querySelector("[data-at-catnav]");
    if (!section || section.dataset.atCatnavReady === "1") {
      if (section && section.dataset.atCatnavReady === "1") return;
    }
    var sections = (root || document).querySelectorAll("[data-at-catnav]");
    sections.forEach(function (sec) {
      if (sec.dataset.atCatnavReady === "1") return;
      sec.dataset.atCatnavReady = "1";

      var rail = sec.querySelector("[data-at-catnav-rail]");
      var cards = Array.prototype.slice.call(sec.querySelectorAll("[data-at-catnav-card]"));
      var dotsWrap = sec.querySelector("[data-at-catnav-dots]");
      var prev = sec.querySelector("[data-at-catnav-prev]");
      var next = sec.querySelector("[data-at-catnav-next]");
      if (!rail || !cards.length) return;

      cards.forEach(function (card) {
        var btn = card.querySelector("[data-at-catnav-toggle]");

        card.addEventListener("click", function (e) {
          if (e.target.closest("a")) return;
          var open = card.classList.contains("is-open");
          closeAll(cards, card);
          setOpen(card, !open);
        });

        if (btn) {
          btn.addEventListener("click", function (e) {
            e.stopPropagation();
            var open = card.classList.contains("is-open");
            closeAll(cards, card);
            setOpen(card, !open);
          });
        }
      });

      if (dotsWrap) {
        dotsWrap.innerHTML = "";
        cards.forEach(function (_, i) {
          var d = document.createElement("button");
          d.type = "button";
          d.className = "at-catnav__dot" + (i === 0 ? " is-active" : "");
          d.setAttribute("aria-label", "Kart " + (i + 1));
          d.addEventListener("click", function () {
            var item = cards[i].closest(".at-catnav__item");
            if (!item) return;
            rail.scrollTo({ left: item.offsetLeft - 16, behavior: "smooth" });
          });
          dotsWrap.appendChild(d);
        });
      }

      function updateDots() {
        var left = rail.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        cards.forEach(function (card, i) {
          var item = card.closest(".at-catnav__item");
          if (!item) return;
          var dist = Math.abs(item.offsetLeft - left);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            dot.classList.toggle("is-active", i === best);
          });
        }
        if (prev) prev.disabled = best === 0;
        if (next) next.disabled = best === cards.length - 1;
      }

      rail.addEventListener(
        "scroll",
        function () {
          window.requestAnimationFrame(updateDots);
        },
        { passive: true }
      );

      function scrollByDir(dir) {
        var item = cards[0].closest(".at-catnav__item");
        var w = (item ? item.offsetWidth : 268) + 16;
        rail.scrollBy({ left: dir * w, behavior: "smooth" });
      }

      if (prev) prev.addEventListener("click", function () { scrollByDir(-1); });
      if (next) next.addEventListener("click", function () { scrollByDir(1); });

      updateDots();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    var sec = event.target && event.target.querySelector
      ? event.target.querySelector("[data-at-catnav]")
      : null;
    if (sec) sec.dataset.atCatnavReady = "";
    init(event.target || document);
  });
})();
